<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="custom"
      @cancel="cancel"
      @confirm="confirm"
      :confirm-loading="loading"
  >
    <template #header>编辑邮箱</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="70px"
      >
        <el-form-item
            prop="name"
            label="用户名"
        >
          <gj-input width="490px" v-model="form.name" placeholder="请输入用户名"></gj-input>
        </el-form-item>
        <el-form-item
            label="账号"
        >
          <gj-input width="490px" disabled :value="item.marketName"></gj-input>
        </el-form-item>
        <el-form-item
            label="国家"
        >
          <gj-input width="490px" disabled :value="countryMap[item.countryCode].text"></gj-input>
        </el-form-item>
        <el-form-item
            required
            label="邮箱账号"
        >
          <gj-input width="490px" disabled :value="item.account"></gj-input>
        </el-form-item>
        <div class="form-item-info" style="margin-top: -10px">
          <a href="http://help.gerpgo.com/web/#/26?page_id=638" target="_blank">如何获取或设置亚马逊邮箱账号？</a>
        </div>
        <el-form-item
            label="密码/密钥"
        >
          <gj-input type="password" width="490px" v-model="form.authCode" placeholder="请输入密码/密钥"></gj-input>
        </el-form-item>
        <div class="form-item-info" style="margin-bottom: 0; margin-top: -10px">1、126，163邮箱需要额外验证，请
          <gj-button @click="hrefValidMail" style="padding: 0" type="text">点此链接</gj-button>
          进行验证
        </div>
        <div class="form-item-info">2、查看教程
          <a href="http://help.gerpgo.com/web/#/26?" target="_blank">《如何获取邮箱授权码》</a>
        </div>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, modalMixIn, responseMixin} from "../../../../../minxins";
  import {isMeaningful, transformToMap} from "../../../../../utils/common";
  import {amazonCountryOption} from "../../../../../utils/options";
  import {updateEmail} from "../../../../../api/crm";

  export default {
    name: "mail-edit-modal",
    mixins: [modalMixIn, formRuleMixin, responseMixin],
    props: {
      item: null,
    },
    created() {
      this.form.id = this.item.id;
      this.form.name = this.item.name;
    },
    data() {
      const validateName = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入用户名'))
        }
        if (value && !value.match(/^[a-z0-9A-Z_]{1,}$/)) {
          return callback(new Error('用户名由字母、下划线、数字构成'))
        }

        callback()
      }
      return {
        loading: false,
        form: {
          name: null,
          id: null,
          authCode: null,
        },
        rules: {
          name: [
            {
              required: true,
              validator: validateName,
              trigger: 'blur'
            }
          ],
        },
        countryMap: transformToMap(amazonCountryOption),
      }
    },
    methods: {
      hrefValidMail() {
        if (isMeaningful(this.item.account)) {
          window.open(`http://config.mail.163.com/settings/imap/login.jsp?uid=${this.item.account}`,"_blank");
        } else {
          this.$gjMessage.warning('请先输入邮箱账号')
        }
      },
      confirm() {
        if (this.$gjFormValidate()) {
          this.loading = true;
          updateEmail(this.form)
            .then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$emit('after');
            })
          }).complete(() => this.loading = false)
        }
      }
    }
  }
</script>

<style scoped>
  /deep/ .gj-modal--custom .el-dialog {
    height: auto !important;
    width: 600px !important;
  }

  .form-item-info {
    height: 20px;
    padding-left: 80px;
    font-size: 12px;
    margin-bottom: 15px;
  }

  /deep/ .el-form-item__error {
    position: initial;
  }

  /deep/ a {
    color: #1F6EEF;
    text-decoration: none;
  }
</style>
